import React, { useEffect, useState } from "react";
import { useChatState } from "../../context/context";
import io from "socket.io-client";
import CloseIcon from "@mui/icons-material/Close";

import { toast } from "react-toastify";
import UserList from "./Section/UserList";
import InitiateUserList from "./Section/InitiateUserList";
import useDebounce from "../../hooks/useDebounce";
import { fathUserApi } from "../../services/notification";

const UsersSection = ({ fetchAgain }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [initiatePharmacist, setInitiatePharmacist] = useState([]);
  const [initiateLoading, setInitiateLoading] = useState(false);
  const [search, setSearch] = useState("");
  const adminId = localStorage.getItem("communityId");
  const debounceValue = useDebounce(search, 300);

  var socket = io(process.env.REACT_APP_API_URL);
  const { user, chats, setChats } = useChatState();
  const [loading, setLoading] = useState(false);

  const fetchUsers = () => {
    const data = {
      loginId: adminId,
      type: "admin",
    };
    socket.emit("navigationChatList", data);
    socket.on("getNavigationChatList", (data) => {
      setChats(data.result);
    });
    // socket.emit("chatList", { loginId: adminId });
    // socket.on("chatUserList", (data) => {
    //   setChats(data.result);
    // });
  };

  const getInitiateUser = async (search = debounceValue) => {
    try {
      setInitiateLoading(true);
      const response = await fathUserApi(search);
      const data = response.data;
      if (data.status === 200) {
        setInitiatePharmacist(data.data.list);
        setInitiateLoading(false);
      } else {
        toast.error(data.message);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || e?.message);
    }
  };
  // its runs only once
  useEffect(() => {
    const fetchUsersList = () => {
      setLoading(true);
      const data = {
        loginId: adminId,
        type: "admin",
      };
      socket.emit("navigationChatList", data);
      socket.on("getNavigationChatList", (data) => {
        setChats(data.result);
        setLoading(false);
      });
    };
    fetchUsersList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line
  }, [fetchAgain]);

  useEffect(() => {
    isFocused && getInitiateUser();
    // eslint-disable-next-line
  }, [isFocused]);

  // it runs when search value changes
  useEffect(() => {
    isFocused && getInitiateUser();
    // eslint-disable-next-line
  }, [debounceValue]);

  return (
    <>
      <div
        className="col-md-6 col-lg-5 col-xl-4 mb-4 mb-md-0"
        style={{ overflow: "scroll" }}
      >
        <div className="p-3">
          <h5>Community Chat</h5>
          <div className="input-group rounded mb-3">
            <input
              type="search"
              className="form-control rounded"
              placeholder="Search"
              aria-label="Search"
              aria-describedby="search-addon"
              onFocus={() => setIsFocused(true)}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {isFocused && (
              <span
                role={"button"}
                onClick={() => {
                  setIsFocused(false);
                  setSearch("");
                }}
                className="input-group-text border-0"
                id="search-addon"
              >
                <CloseIcon />
              </span>
            )}
          </div>

          <div
            data-mdb-perfect-scrollbar="true"
            style={{ position: "relative", height: "400px" }}
          >
            <ul className="list-unstyled mb-0">
              {isFocused ? (
                <InitiateUserList
                  initiateLoading={initiateLoading}
                  initiatePharmacist={initiatePharmacist}
                  socket={socket}
                  onClose={() => setIsFocused(false)}
                />
              ) : (
                <UserList chats={chats} loading={loading} />
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
export default UsersSection;
